import axios from "axios";

export async function fetchSheetRows(SHEET_URL) {
  const res = await axios.get(SHEET_URL);
  const rawData = JSON.parse(res.data.substr(47).slice(0, -2));
  return rawData.table.rows.map(row => ({
    license: row.c[4]?.v?.toString() ?? "",
    password: row.c[5]?.v?.toString() ?? "",
    schoolName: row.c[0]?.v ?? "",
    standard: row.c[1]?.v ?? "",
    volume: row.c[2]?.v ?? "",
    name: row.c[3]?.v ?? "",
    status: row.c[6]?.v ?? "",
    last_used_on: row.c[8]?.f ?? "",
    prime: row.c[9]?.v ?? "",
    type: row.c[10]?.v ?? "",
    dob: row.c[11]?.f ?? "",
  }));
}